<!-- 二维码管理页面侧边栏 -->
<template>
<ul class="menu">
    <router-link class="menu-item"  tag="li" to="/labelManage">
      <i class="fa fa-tags menu-icon"></i><div class="text-h4">便签</div>
    </router-link>
    
    <router-link class="menu-item" tag="li" to="/analysis">
      <i class="fas fa-chart-pie fa-lg menu-icon"></i><div class="text-h4">数据分析</div>
    </router-link>

    <!-- <router-link class="menu-item" tag="li" to="/announcement">
      <i class="fa fa-bell menu-icon"></i><div class="text-h4">公告</div>
    </router-link> -->

    <router-link class="menu-item" tag="li" to="/userMessage">
      <i class="fa fa-user menu-icon"></i><div class="text-h4">个人信息</div>
    </router-link>

    <router-link class="menu-item" tag="li" to="/security">
      <i class="fas fa-shield-alt fa-lg menu-icon"></i><div class="text-h4">安全中心</div>
    </router-link>

    <router-link class="menu-item" tag="li" to="/feedback">
      <i class="far fa-envelope menu-icon fa-lg"></i><div class="text-h4">用户反馈</div>
    </router-link>
</ul>
</template>

<script type="text/javascript">
export default {
  name: 'manageVerticalNavigation'
}
</script>

<style scoped>
.menu {
  padding: 0;
  margin: 0;
}
.menu-icon {
  font-size: 18px;
  margin: 13px auto 3px;
  color: white;
}
.menu-item {
  cursor: pointer;
  color: white;
  height: 60px;
  text-align: center;
  background-color: #333333;
}
.menu-item.router-link-active {
  background-color: #5c5c5c;
}
.menu-item:hover {
  background-color: #484848;
}

</style>
